import { render, staticRenderFns } from "./quotaManage.vue?vue&type=template&id=7921e421&scoped=true&"
import script from "./quotaManage.vue?vue&type=script&lang=js&"
export * from "./quotaManage.vue?vue&type=script&lang=js&"
import style0 from "./quotaManage.vue?vue&type=style&index=0&id=7921e421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7921e421",
  null
  
)

export default component.exports